import React from 'react';
export function Navbar() {
  const scrollToContact = () => {
    document.getElementById('contact-form')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <nav className="fixed top-0 left-0 right-0 z-50 bg-cream/90 backdrop-blur-md border-b border-charcoal/10" data-id="element-139">
      <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between" data-id="element-140">
        <a href="#" className="flex items-center gap-3" data-id="element-141">
          <img src="https://cdn.magicpatterns.com/uploads/799mPWW6cpXQHxrnoqEoJr/logofin-05.png" alt="AB Dubai Beauty Advisory" className="h-12 w-auto object-contain" data-id="element-142" />
          <div className="font-serif text-base font-semibold tracking-wide leading-tight hidden sm:block" data-id="element-143">
            DUBAI BEAUTY
            <br data-id="element-144" />
            <span className="text-[10px] font-sans font-normal tracking-[0.2em] text-charcoal-light uppercase" data-id="element-145">
              Advisory
            </span>
          </div>
        </a>

        <div className="hidden md:flex items-center gap-8 text-sm font-medium tracking-wide" data-id="element-146">
          <a href="#services" className="hover:text-gold transition-colors" data-id="element-147">
            Services
          </a>
          <a href="#market" className="hover:text-gold transition-colors" data-id="element-148">
            The Market
          </a>
          <a href="#approach" className="hover:text-gold transition-colors" data-id="element-149">
            Our Approach
          </a>
        </div>

        <button onClick={scrollToContact} className="bg-charcoal text-white px-6 py-3 text-sm font-medium tracking-wide hover:bg-gold transition-colors duration-300" data-id="element-150">
          Request Consultation
        </button>
      </div>
    </nav>;
}